/* Global <img> auto-retry for /api/files/ thumbnails.

   During a gallery's thumbnail warm-up (right after upload or a redeploy),
   some tile requests can fail while the backend is still generating variants.
   Without this, a failed <img> shows a broken icon FOREVER even though the
   thumbnail becomes available seconds later. Event delegation on the window
   (error events don't bubble, so we use capture) retries any failed
   /api/files/ image up to 3 times with backoff — no per-component wiring. */

const MAX_RETRIES = 3;
const DELAYS_MS = [2500, 6000, 12000];

export function installImgRetry() {
  window.addEventListener(
    "error",
    (e) => {
      const img = e.target;
      if (!img || img.tagName !== "IMG") return;
      const src = img.getAttribute("src") || "";
      if (!src.includes("/api/files/")) return;
      const tries = Number(img.dataset.retryCount || 0);
      if (tries >= MAX_RETRIES) return;
      if (!img.dataset.retryBase) {
        // Strip any previous retry param so the base URL stays stable.
        img.dataset.retryBase = src.replace(/([?&])retry=\d+&?/, "$1").replace(/[?&]$/, "");
      }
      img.dataset.retryCount = String(tries + 1);
      const base = img.dataset.retryBase;
      const sep = base.includes("?") ? "&" : "?";
      setTimeout(() => {
        // Cache-buster defeats any negative caching of the failed response.
        img.src = `${base}${sep}retry=${tries + 1}`;
      }, DELAYS_MS[tries] || 12000);
    },
    true,
  );
}
